module.exports = __webpack_public_path__ + "static/media/CCU_Arg-18.c490a7fb.png";